import React from "react";
import { CardOption, Radio, Image } from "./styles";
import { Ptag } from "../fonts";
import activeIcon from "assets/svgs/Active.svg";

const Card = ({ title, selected, onChange }) => {
  return (
    <Radio onClick={onChange} selected={selected}>
      <Ptag fontSize="14px" fontWeight="500" marginLeft="16px" marginTop="10px" marginBottom="10px" color={`${selected?'white':''}`}>{title}</Ptag>
      {selected && <Image src={activeIcon} style={{
        height: "20px"
      }}/>}
    </Radio>
  )
};
export default Card;

